var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSuccess(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37.7618 18.9536C38.7381 17.9772 40.321 17.9772 41.2973 18.9536C42.2736 19.9299 42.2736 21.5128 41.2973 22.4891L28.1353 35.648C25.6974 38.0853 21.7464 38.0885 19.3046 35.655L14.7678 31.1337C13.7915 30.1574 13.7915 28.5745 14.7678 27.5982C15.7441 26.6219 17.327 26.6219 18.3033 27.5982L21.9425 31.2374C22.9188 32.2137 24.5017 32.2137 25.478 31.2374L37.7618 18.9536Z",
    fill: "#04C58B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28 55.5C43.1878 55.5 55.5 43.1878 55.5 28C55.5 12.8122 43.1878 0.5 28 0.5C12.8122 0.5 0.5 12.8122 0.5 28C0.5 43.1878 12.8122 55.5 28 55.5ZM28 50.4829C15.583 50.4829 5.51708 40.417 5.51708 28C5.51708 15.583 15.583 5.51708 28 5.51708C40.417 5.51708 50.4829 15.583 50.4829 28C50.4829 40.417 40.417 50.4829 28 50.4829Z",
    fill: "#04C58B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccess);
export default __webpack_public_path__ + "static/media/success.950eeec0450daa6af7103bc1e5eafcee.svg";
export { ForwardRef as ReactComponent };